import {
    browserName,
    browserVersion,
    engineName,
    engineVersion,
    fullBrowserVersion,
    isTablet,
    mobileModel,
    mobileVendor,
    osName,
    osVersion,
} from 'react-device-detect'

import { meetsAxiosProtected } from 'services/httpInstance/http'

import { isDesktop, isMobilePhone } from '../../utils/device'

export const saveUserDeviceProfile = async ({
    roomName,
    userId,
    upSpeedKbps = 0,
    downSpeedKbps = 0,
    status = 'pass',
    reason = '',
}) => {
    let payload = {
        browser_full_version: fullBrowserVersion,
        browser_name: browserName,
        browser_version: browserVersion,
        screen_width: window.screen.width,
        screen_height: window.screen.height,
        device_type: null,
        down_speed_kbps: downSpeedKbps,
        engine_name: engineName,
        engine_version: engineVersion,
        mobile_model: mobileModel,
        mobile_vendor: mobileVendor,
        os_name: osName,
        os_version: osVersion,
        reason,
        room: roomName,
        status,
        up_speed_kbps: upSpeedKbps,
        user_id: userId,
    }

    if (isDesktop) {
        payload.device_type = 'Computer'
    } else if (isMobilePhone) {
        payload.device_type = 'Mobile'
    } else if (isTablet && !isMobilePhone) {
        payload.device_type = 'Tablet'
    }

    return meetsAxiosProtected.post(`/user_device_profile/`, payload)
}
